<template>
  <div>
    <el-row>
      <el-col :span="5">
        <span class="icon iconfont">&#xe67f;</span>
        <span class="smallTile">运行模态</span>
      </el-col>
      <el-col :span="4">
        <el-row>
          <div class="modUtilRate ">模型投用率：{{resultData.useRate}}%</div>
        </el-row>
      </el-col>
      <el-col :span="10">
        <el-row>
          <div class="state_sta">
            <ul>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>
        </el-row>
        <el-row>
          <div>
            <ul>
              <li>模型总量</li>
              <li>离线</li>
              <li>正常</li>
              <li>预警</li>
              <li>报警</li>
            </ul>
          </div>
        </el-row>
        <el-row>
          <div>
            <ul>
              <li>{{ resultData.allModelNum }}</li>
              <li>{{ resultData.offLineNum }}</li>
              <li>{{ resultData.normalNum }}</li>
              <li>{{ resultData.warnNum }}</li>
              <li>{{ resultData.alarmNum }}</li>
            </ul>
          </div>
        </el-row>
      </el-col>
      <el-col :span="2">
        <el-row>
          <div>系统状态 ：</div>
          <div>通讯状态 ：</div>
        </el-row>
      </el-col>
      <el-col :span="3">
        <el-row>
          <div class="sysStatus" :style="{background: resultData.sysStatus == 1 ? 'rgb(32, 223, 32)' : 'yellow',}"></div>
        </el-row>
        <el-row>
          <div class="comStatus" :style="{background: resultData.comStatus == 1 ? 'rgb(32, 223, 32)' : 'yellow',}"></div>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="device_pic">
          <div class="device_bg">
            <div
              class="model_bg"
              v-bind:style="{ backgroundColor: modelStatusColor.PVC_YQQG }"
            ></div>
            <div class="model_name cursor" @click="jumpModelPage('DJ_DJC')">
              电解槽
            </div>
            <div
              class="mode2_bg"
              v-bind:style="{ backgroundColor: modelStatusColor.PVC_JLGT }"
            ></div>
            <div class="mode2_name cursor" @click="jumpModelPage('DJ_YLCC')">
              液氯储槽
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Message } from "element-ui";
import { homePage } from "@/api/wormBox"
import { jumpModelBtn} from "@/utils/control"
import { mapState ,mapMutations} from "vuex"
export default {
  data() {
    return {
      updateInterval: 10000,
      timerStart: 0,
      resultData:{
        allModelNum:0,
        offLineNum:0,
        normalNum:0,
        warnNum:0,
        alarmNum:0,
        comStatus:1,
        sysStatus:1,
        modelList:[],
        useRate:null
      },
      modelStatusColor:{},
      // 传参数
      params:{
        startTime:null,
        endTime:null,
        workShopName:""
      },
      timerId: null
    };
  },
  computed:{
    ...mapState(["hisParams","isHis","homePageRunStateInfo"]),
  },
  methods:{
    ...mapMutations(["setIsHis"]),
    getData(){
      // const params = {
      //   workShopName: this.$route.query.homePage,
      //   startTime: this.hisParams.startTime,
      //   endTime: this.hisParams.endTime
      // }
      // const {code , resultData} =  await homePage(params)
      // if(code == "200"){
      //   this.resultData = resultData.runStateInfo
      //   this.resultData.modelList.forEach((item) => {
      //     this.modelStatusColor[item.modelFullName] = item.color
      //   })
      // }
      if(this.homePageRunStateInfo != null){
        this.resultData = this.homePageRunStateInfo
        this.resultData.modelList.forEach((item) => {
          this.modelStatusColor[item.modelFullName] = item.color
        })
      }
    },
     // 定时器方法
     startTimer() {
      this.timerId = setInterval(() => {
        this.getData()
      }, 3000);
    },
    stopTimer() {
      // 停止定时器
      clearInterval(this.timerId);
    },
    jumpModelPage(curPage){
      this.resultData.modelList.forEach((item,index) => {
        if(curPage == item.modelFullName && item.hasRole == true){
          jumpModelBtn(item.modelUrl,curPage,index+1,this.$route.query.homePage)
        }else if(curPage == item.modelFullName && item.hasRole == false){
          Message.error("您没有权限进入该模型")
        }
      })
      this.isHis == 2 ? this.setIsHis(0) : this.setIsHis(1)
    },
  },
  created() {
    this.getData()
  },
  mounted(){
    this.startTimer()
  },
  destroyed(){
    this.stopTimer()
  }
};
</script>

<style lang="less" scoped>
.cursor {
  cursor: pointer
}
ul {
  margin: 5px 5px;
  li {
    float: left;
    list-style: none;
    width: 80px;
    text-align: center;
    font-size: 18px;
    height: 20px;
    line-height: 20px;
  }
}
.state_sta {
  ul {
    :nth-child(1) {
      border: 1px solid grey;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
      height: 8px;
    }
    :nth-child(2) {
      background: grey;
      height: 10px;
    }
    :nth-child(3) {
      background: rgb(32, 223, 32);
      height: 10px;
    }
    :nth-child(4) {
      background: yellow;
      height: 10px;
    }
    :nth-child(5) {
      background: red;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      height: 10px;
    }
  }
}
.smallTile{
  font-size: 25px;
}
.device_pic {
  position: relative;
  .device_bg,
  .model_bg,
  .mode2_bg,
  .sys_statusBg,
  .com_statusBg {
    position: absolute;
  }
  .device_bg {
    background: url(~@/assets/imgs/ZZT.png) no-repeat center;
    background-size: 100% 100%;
    height: 350px;
    width: 100%;
  }
  .model_bg {
    width: 76px;
    height: 20px;
    border-radius: 50%;
    //background: red;
    left: 550px;
    top: 120px;
  }
  .model_name,
  .mode2_name,
  .sys_status,
  .com_status {
    position: absolute;
    font-size: 15px;
  }
  .model_name {
    left: 650px;
    top: 95px;
  }
  .mode2_bg {
    width: 75px;
    height: 20px;
    border-radius: 50%;
    // background: rgb(32, 223, 32);
    left:640px;
    top: 110px;
  }
  .mode2_name {
    left: 525px;
    top: 105px;
  }
}

.modUtilRate{
  font-size: 18px;
}
.sysStatus , .comStatus{
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-top: 5px;
}

</style>
